module.exports = __webpack_public_path__ + "img/logotyp_pwr_kolor.f24edcaa.png";